export default "__VITE_ASSET__DuHoqTGy__"